/* eslint-disable no-console */
import { getAgeFromDateString } from '..';

const requiredVal = (val: string) => {
  return val !== undefined && val !== '';
};

const maxLengthVal = (max: number) => (val: string) => val.length < max;

/* eslint-disable no-useless-escape */
const validEmailVal = (email: string) => {
  // eslint-disable-next-line max-len
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

const minAgeVal = (min: number) => (val: string) => {
  const age = getAgeFromDateString(val);

  if (!age) {
    return false;
  }

  return age >= min;
};

const minVal = (min: number) => (val: string) => {
  if (!val) {
    return false;
  }

  return Number(val) >= min;
};

const maxAgeVal = (max: number) => (val: string) => {
  const age = getAgeFromDateString(val);

  if (!age && age !== 0) {
    return false;
  }

  return age <= max;
};

const maxVal = (max: number) => (val: string) => {
  if (!val) {
    return false;
  }

  return Number(val) <= max;
};

export const required = {
  validation: requiredVal,
  msg: 'Dit veld is verplicht',
};

export const maxLength = (max: number, msg?: string) => {
  return {
    validation: maxLengthVal(max),
    msg: msg ?? `Maximaal ${max} tekens toegestaan`,
  };
};

export const maxAge = (max: number) => {
  return {
    validation: maxAgeVal(max),
    msg: `De maximum leeftijd is ${max} jaar`,
  };
};

export const minAge = (min: number) => {
  return {
    validation: minAgeVal(min),
    msg: `De minimum leeftijd is ${min} jaar`,
  };
};

export const maxValue = (max: number) => {
  return {
    validation: maxVal(max),
    msg: `De maximumwaarde is ${max}`,
  };
};

export const minValue = (min: number) => {
  return {
    validation: minVal(min),
    msg: `De minimumwaarde is ${min}`,
  };
};

export const validEmail = {
  validation: validEmailVal,
  msg: 'Gelieve een geldig e-mailadres in te geven',
};
